<template>
  <div class="bodycontent">
    <div class="page_title">功能模块讲解</div>
    <div class="boxC">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="type.name"
          :name="type.id"
          v-for="type in typeList"
          :key="type.id"
        >
          <div class="shop-con">
            <div
              class="shop-con-item"
              v-for="item in teachList"
              :key="item.id"
              @click="showContent(item)"
            >
              <el-image :src="item.url"></el-image>
              <span class="demonstration">{{ item.title }}</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="page">
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="page"
        :total="total"
        :page-size="18"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog :visible.sync="showDetail" :title="title" @close="closeDetail()">
      <div v-html="content"></div>
      <div style="margin-top:20px;color:#999">{{ describe }}</div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getTeachList, getTeachType } from "@/api/set";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      activeName: "",
      typeList: [], // 类型列表
      teachList: [], // 文章列表
      showDetail: false, // 文章详情弹窗
      content: "", //文章内容
      title: "", //文章标题
      describe: "", // 文章描述
      page: 1,
      total: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    handleCurrentChange(p) {
      this.page = p;
      this.getList();
    },
    // 获取类型列表
    init() {
      getTeachType({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.typeList = res.data;
          this.typeList.forEach(item => {
            item.id = String(item.id);
          });
          this.activeName = this.typeList[0].id;
          this.getList();
        }
      });
    },
    // 获取文章列表
    getList() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        cate_id: this.activeName,
        page: this.page
      };
      getTeachList(data).then(res => {
        if (res.code == 200) {
          this.teachList = res.data.data;
          this.teachList.forEach(item => {
            if (item.content.split("<video").length > 1) {
              var contentArr = item.content.split("<video");
              contentArr.splice(1, 0, '<video style="width:100%"');
              item.content = contentArr.join("");
            }
          });
          this.total = res.data.total;
          this.page = res.data.current_page;
        }
      });
    },
    // 切换tab页
    handleClick(val) {
      console.log(val);
      this.getList();
    },
    // 文章详情
    showContent(item) {
      console.log(item);
      this.title = item.title;
      this.content = item.content;
      this.describe = item.describe;
      this.showDetail = true;
    },
    // 关闭弹窗
    closeDetail() {
      this.showDetail = false;
      var vide = document.getElementsByTagName("video")[0];
      vide.pause();
    }
  }
};
</script>
<style lang="scss" scoped>
.bodycontent {
  border: 20px solid #f0f2f5;
  height: 100%;
  padding: 0 18px;
  display: flex;
  flex-direction: column;
  .page_title {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .shop-con {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-top: 40px;
    margin-top: -40px;
    .shop-con-item {
      width: 290px;
      height: 246px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      margin-top: 20px;
      margin-left: 20px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      .demonstration {
        line-height: 50px;
        text-align: center;
        font-size: 16px;
      }
      .demonstration::hover {
        color: cornflowerblue;
      }
    }
  }
  .boxC {
    flex: 1;
    overflow: auto;
  }
  .page {
    height: 60px;
    padding-top: 10px;
  }
}
</style>
